module.exports = __webpack_public_path__ + "static/media/Not_My_Monkeys_Podcast_Logo_NoText_800x800.b5bb9252.png";